import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "titleProps", "handleClick", "expandedItemTitleId", "bodyProps"],
      _excluded2 = ["title", "id", "titleDetails"],
      _excluded3 = ["classes"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { Button, IconCollapse, IconExpand } from "../../index";
import { ACCORDION_ITEM_BODY_CLASS, ACCORDION_ITEM_CLASS, ACCORDION_ITEM_ICON_CLASS, ACCORDION_ITEM_TITLE_CLASS, ACCORDION_ITEM_TITLE_TEXT_CLASS, HIDDEN, VISIBLE } from "../../themes/common/classes";
import extractTheme from "./extractTheme";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const ICON_SIZE = "xsmall";
/**
 * AccordionItem is a React component which is displayed as a collapsible section.
 */

function AccordionItem(_ref) {
  let {
    children,
    className,
    titleProps,
    handleClick,
    expandedItemTitleId,
    bodyProps
  } = _ref,
      elementProps = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  const {
    cssRoot,
    cssTitle,
    cssBody
  } = extractTheme({
    theme
  });

  const {
    title,
    id,
    titleDetails
  } = titleProps,
        titleElementProps = _objectWithoutProperties(titleProps, _excluded2);

  const titleDetailsId = `${id}__details`;

  const {
    classes: bodyClasses
  } = bodyProps,
        bodyElementProps = _objectWithoutProperties(bodyProps, _excluded3);

  const expanded = id === expandedItemTitleId;
  const accordionItemContainerClasses = clsx(ACCORDION_ITEM_CLASS, className, {
    [`${ACCORDION_ITEM_CLASS}--expanded`]: expanded,
    [`${ACCORDION_ITEM_CLASS}--collapsed`]: !expanded
  });
  const titleClassNames = clsx(ACCORDION_ITEM_TITLE_CLASS, {
    [`${ACCORDION_ITEM_TITLE_CLASS}--selected`]: expanded
  });
  const bodyClassNames = clsx(ACCORDION_ITEM_BODY_CLASS, {
    bodyClasses
  });
  return _jsxs("div", _objectSpread(_objectSpread({
    css: cssRoot
  }, elementProps), {}, {
    className: accordionItemContainerClasses,
    children: [titleDetails && _jsx("span", {
      id: titleDetailsId,
      hidden: true,
      children: titleDetails
    }), _jsxs(Button, _objectSpread(_objectSpread({
      fullWidth: true,
      kind: "simple",
      onClick: handleClick,
      className: titleClassNames,
      css: cssTitle,
      id: id,
      "aria-describedby": titleDetails ? titleDetailsId : null,
      "aria-expanded": expanded
    }, titleElementProps), {}, {
      children: [_jsx("span", {
        className: `${ACCORDION_ITEM_ICON_CLASS}--${expanded ? VISIBLE : HIDDEN}`,
        children: _jsx(IconCollapse, {
          size: ICON_SIZE,
          decorative: true
        })
      }), _jsx("span", {
        className: `${ACCORDION_ITEM_ICON_CLASS}--${expanded ? HIDDEN : VISIBLE}`,
        children: _jsx(IconExpand, {
          size: ICON_SIZE,
          decorative: true
        })
      }), _jsx("span", {
        className: ACCORDION_ITEM_TITLE_TEXT_CLASS,
        children: title
      })]
    })), _jsx("div", _objectSpread(_objectSpread({
      className: bodyClassNames
    }, bodyElementProps), {}, {
      css: cssBody,
      children: expanded && children
    }))]
  }));
}

AccordionItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Props that are needed for Item body */
  bodyProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** Content that is displayed inside the Item body */
  children: PropTypes.node,

  /** Class names that will be applied to Accordion Item */
  className: PropTypes.string,

  /** Accordion Item title id that is currently expanded */
  expandedItemTitleId: PropTypes.string,

  /** Handler that will be executed on click of Item title */
  handleClick: PropTypes.func,

  /** Props that are needed for Item title */
  titleProps: PropTypes.object // eslint-disable-line react/forbid-prop-types

} : {};
AccordionItem.defaultProps = {
  bodyProps: {},
  children: null,
  className: null,
  expandedItemTitleId: "",
  handleClick: null,
  titleProps: {}
};
export default AccordionItem;